import React from 'react';

const Card = ({ icon, title, text, children, className = '' }) => {
    return (
        <div className={`card ${className}`}>
            {icon && <div className="card-icon">{icon}</div>}
            {title && <h3 className="card-title">{title}</h3>}
            {text && <p className="card-text">{text}</p>}
            {children}
        </div>
    );
};

export default Card;
